<div
  class="node-config-dialog"
  [ngClass]="{ 'dark-theme': _isDarkTheme, 'light-theme': _isLightTheme, 'paper-theme': _isPaperTheme }"
>
  <!-- Header -->
  <div class="dialog-header">
    <h2>{{ data.title }}</h2>
    <div class="dialog-header-actions">
      @if (data.infoTooltip) {
        <button class="info-btn" [matTooltip]="data.infoTooltip">
          <mat-icon>info_outline</mat-icon>
        </button>
      }
      <button class="close-btn" (click)="cancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="dialog-content">
    @if (data.contentType === 'attachment') {
      <input
        #imageInput
        accept="image/*"
        multiple
        style="display: none"
        type="file"
        (change)="onImageSelected($event)"
      />
      <button class="upload-btn" (click)="triggerImagePicker(imageInput)">
        <mat-icon>upload</mat-icon>
        <span>Upload images</span>
      </button>

      <div class="image-list">
        @if (data.config['images']?.length) {
          @for (img of data.config['images']; track img.name; let i = $index) {
            <div class="image-list-item">
              <mat-icon class="image-list-icon">image</mat-icon>
              <span class="image-list-name">{{ img.name }}</span>
              <button class="image-remove-btn" matTooltip="Remove" (click)="removeImage(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        } @else {
          <div class="empty-state">No images selected</div>
        }
      </div>
    }

    @if (data.contentType === 'create-node') {
      <p class="config-label">Prompt</p>
      <textarea
        class="prompt-textarea"
        placeholder="Enter a prompt for this create node..."
        rows="4"
        [(ngModel)]="prompt"
        (keydown)="$event.stopPropagation()"
      ></textarea>

      @if (isFigureSubType) {
        <p class="config-label">Figure style</p>
        <mat-radio-group class="figure-style-group" [(ngModel)]="figureStyle">
          <div class="figure-style-option">
            <mat-radio-button value="bold">
              <div class="style-option-content">
                <mat-icon>format_bold</mat-icon>
                <span>Bold</span>
              </div>
            </mat-radio-button>
          </div>
          <div class="figure-style-option">
            <mat-radio-button value="flat">
              <div class="style-option-content">
                <mat-icon>dashboard</mat-icon>
                <span>Flat</span>
              </div>
            </mat-radio-button>
          </div>
          <div class="figure-style-option">
            <mat-radio-button value="cute">
              <div class="style-option-content">
                <mat-icon>favorite</mat-icon>
                <span>Cute</span>
              </div>
            </mat-radio-button>
          </div>
        </mat-radio-group>
      }
    }

    @if (data.contentType === 'create-figure') {
      <p class="config-label">Figure style</p>
      <mat-radio-group class="figure-style-group" [(ngModel)]="figureStyle">
        <div class="figure-style-option">
          <mat-radio-button value="bold">
            <div class="style-option-content">
              <mat-icon>format_bold</mat-icon>
              <span>Bold</span>
            </div>
          </mat-radio-button>
        </div>
        <div class="figure-style-option">
          <mat-radio-button value="flat">
            <div class="style-option-content">
              <mat-icon>dashboard</mat-icon>
              <span>Flat</span>
            </div>
          </mat-radio-button>
        </div>
        <div class="figure-style-option">
          <mat-radio-button value="cute">
            <div class="style-option-content">
              <mat-icon>favorite</mat-icon>
              <span>Cute</span>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    }
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="cancel-btn" (click)="cancel()">Cancel</button>
    <button class="configure-btn" (click)="configure()">Configure</button>
  </div>
</div>
